export enum Direction {
    ascending = "ascending",
    descending = "descending"
}
